export default __webpack_public_path__ + "static/media/Navaratri_2056.6ccd1a09.gif";